import { useQuery } from '@tanstack/react-query';
import type AgentApiAiJobSearchRunsResults from '@/types/serializers/AgentApiAiJobSearchRunsResults';

/** AI求人検索ランの結果を取得するクエリ */
export default function useFetchAiJobSearchRunResults(runId: number | null) {
  return useQuery({
    queryKey: ['aiJobSearchRunResults', runId],
    enabled: runId !== null,
    queryFn: async (): Promise<AgentApiAiJobSearchRunsResults> => {
      const response = await fetch(`/agent/api/ai_job_search_runs/${runId}/results`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error('検索結果の取得に失敗しました');
      }

      const data: AgentApiAiJobSearchRunsResults = await response.json();
      return data;
    },
    refetchOnWindowFocus: false,
  });
}
